<template>
  <div class="wl-container">
    <div class="center">
      <p class="title">{{$t('PAGE_NEXTYEAR_ORG_TITLE')}}</p>
      <Org :initData="clientEntityTree" :onChangeFun="orgChange" :onOrgFun="getOrg" ref="org"/>
      <p class="title">{{$t('COMMON_PBC_LIST')}}</p>
      <PbcList :onChangeAcitve="changeAcitve" :loading="pbcLoading" :initData="pbcList" :onPbcList="getPbc" ref="pbc"/>
      <p class="title">{{$t('client003')}}</p>
      <MatterLog :onChangeAcitve="changeAcitve2" :initData="matterList" :loading="matterLoading"
                 :onMatterList="getMatter" ref="matter"/>
    </div>
    <el-row class="top-btn">
      <el-button class="wl-grey">
        {{$t('comment_reSet')}}
      </el-button>
      <el-button @click="save" class="wl-green">
        {{$t('btn_save')}}
      </el-button>
    </el-row>
    <SavePop v-if="addVisible"
             :onAdd="addDelayDay"
             :onCancel="cancel"/>
  </div>
</template>
<script>
    import API from '@/api';
    import Org from './org';
    import PbcList from './pbcList'
    import MatterLog from './matterLog'
    import SavePop from './savePop'
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                addVisible: false,
                pbcAuditType: '1',
                clientEntityTree: [],
                pbcList: [],
                matterList: [],
                checkedTreeId: [],
                pbcLoading: false,
                matterLoading: false,
                matterAuditType: '1',
                checkedEntityTree: [],
                checkedPbcList: [],
                checkedMatterList: [],
                retainUserAndRole: false,
                retainTeamMember: false,
                retainInsight: false
            };
        },
        mounted() {
            this.pbcAuditType = this.matterAuditType = this.getSite.hasInterim ? '1' : '2'
            this.getClientEntityTree()
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite',
            })
        },
        methods: {
            changeAcitve(data) {
                this.pbcAuditType = data
            },
            changeAcitve2(data) {
                this.matterAuditType = data
            },
            orgChange(data) {
                this.checkedTreeId = data
                this.getPbcByEntity()
                this.getMatterLogByEntity()
            },
            getMatterLogByEntity() {
                this.matterLoading = !this.matterLoading
                const params = {
                    entityIdList: this.checkedTreeId,
                    siteId: this.getSite.siteId
                }
                API.general.queryMatterLogByEntity(params).then(res => {
                    if (res.code == '1') {
                        this.matterList = res.data
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.matterLoading = !this.matterLoading
                })
            },
            getPbcByEntity() {
                this.pbcLoading = !this.pbcLoading
                const params = {
                    entityIdList: this.checkedTreeId
                }
                API.general.queryPbcByEntity(params).then(res => {
                    if (res.code == '1') {
                        this.pbcList = res.data
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.pbcLoading = !this.pbcLoading
                })
            },
            getClientEntityTree() {
                API.general.queryGeneral({siteId: this.getSite.siteId}).then(res => {
                    if (res.code == '1') {
                        this.clientEntityTree = [res.data.clientEntityTree]
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                })
            },
            cancel() {
                this.addVisible = !this.addVisible
            },
            getOrg(data) {
                this.checkedEntityTree = data
            },
            getPbc(data) {
                this.checkedPbcList = data
            },
            getMatter(data) {
                this.checkedMatterList = data.matter
                this.retainUserAndRole = data.insights
                this.retainTeamMember = data.clientModel
                this.retainInsight = data.KPMGModel
            },
            addDelayDay(data) {
                this.delayDay = data.day
                this.addVisible = !this.addVisible
                this.submit()
            },
            save() {
                this.addVisible = !this.addVisible
                this.$refs.org.onConfirm()
                this.$refs.pbc.onConfirm()
                this.$refs.matter.onConfirm()
            },
            submit() {
                const params = {
                    entityIdList: this.checkedEntityTree,
                    pbcGroupIdList: this.checkedPbcList,
                    matterLogIdList: this.checkedMatterList,
                    siteId: this.getSite.siteId,
                    delayDay: this.delayDay,
                    retainUserAndRole: this.retainUserAndRole,
                    retainTeamMember: this.retainTeamMember,
                    retainInsight: this.retainInsight
                }
                API.general.saveRemainInfo(params).then(res => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.$router.push('/settingHome')
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                })
            }
        },
        components: {
            Org,
            PbcList,
            MatterLog,
            SavePop
        }
    };
</script>

<style scoped>
  .wl-container {
    height: 100%;
    background: #f0f0f0;
    padding: 12px;
  }

  .center {
    background-color: #fff;
    padding-bottom: 20px;
  }

  .top-btn {
    text-align: right;
    margin-top: 10px;
  }

  .title {
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    color: #696969;
    line-height: 40px;
    padding: 8px 0 8px 10px;
  }
</style>
